import { IResult } from '../models/result-model';
import { Result } from '../models/result-viewmodel';
import DateTimeMapper from '@/shared/mappings/date-time-mapper';

/**
 * Mapper for the Search Results
 */

export default class ResultMapper {
    public mapResult(item: IResult): Result {
        return new Result(
            item.Title,
            item.IntroText,
            DateTimeMapper.mapItem(item.SubTitle, item.Language),
            item.Url,
            item.Details,
            item.ImageAlt,
            item.ImageUrl
        );
    }
}
